module.exports = {
  PUBLIC_PATH:process.env.VUE_APP_PUBLIC_PATH,
  API_ROOT_URL:process.env.VUE_APP_API_ROOT,
  HTTP_PROXY:process.env.VUE_APP_HTTP_PROXY
}
